"use client";

import { Box, Grid, Stack } from "@mui/material";

import type { StoreData } from "@/server-fns/booking/query";
import type { BookingIntent } from "@/types/booking-intent";

import { Form } from "./Form";
import { StoreInfo } from "./StoreInfo";

type Props = {
    storeId: string;
    storeData: StoreData;
    bookingIntent: BookingIntent | null;
    onBackToAI: () => void;
};

export const ManualView = ({ storeId, storeData, bookingIntent, onBackToAI }: Props) => {
    return (
        <Grid container spacing={{ xs: 3, md: 6 }} justifyContent="center">
            {/* Left Column (Desktop) / Top Section (Mobile) */}
            <Grid size={{ xs: 12, md: 5 }}>
                <Stack spacing={4}>
                    {/* Banner is always at the top of its section */}
                    <StoreInfo data={storeData} variant="banner" />

                    {/* Detail cards are hidden here on mobile and shown at the very bottom instead */}
                    <Box sx={{ display: { xs: "none", md: "block" } }}>
                        <StoreInfo data={storeData} variant="stacked" />
                    </Box>
                </Stack>
            </Grid>

            {/* Right Column (Desktop) / Middle Section (Mobile) */}
            <Grid size={{ xs: 12, md: 7 }}>
                <Form
                    storeId={storeId}
                    storeData={storeData}
                    initialValues={bookingIntent}
                    onBackToAI={onBackToAI}
                />
            </Grid>

            {/* Bottom Section (Mobile Only) */}
            <Grid size={12} sx={{ display: { xs: "block", md: "none" } }}>
                <StoreInfo data={storeData} variant="stacked" />
            </Grid>
        </Grid>
    );
};
